import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { config } from '../config';
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_SERVER, // Update this to match your server's address and port
    timeout: 350000,
  headers: {
    'Content-Type': 'application/json',
  },
});

function useAuthenticatedAxios() {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  apiClient.interceptors.request.use(
    async (config) => {
      const token = await getAccessTokenSilently();
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(

    (response) => {
      return response;
    },
    async (error) => {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        await loginWithRedirect();
      } else if (status === 400) {
        // TODO move to not allowed page
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
}

export default useAuthenticatedAxios;
